export const values = {
	week_tab : "Week",
	day_tab : "Day",
	month_tab : "Month",
	icon_today : "Today",
	icon_add:"Add",
	icon_save : "Save",
	icon_done : "Done",
	icon_delete : "Delete event",
	icon_cancel : "Cancel",
	icon_edit : "Edit",
	icon_back : "Back",
	icon_close : "Close form",
	icon_yes : "Yes",
	icon_no : "No",
	icon_prev_day:"Previous day",
	icon_next_day:"Next week",
	icon_prev_week:"Previous week",
	icon_next_week:"Next day",
	confirm_closing : "Your changes will be lost, are your sure ?",
	confirm_deleting : "The event will be deleted permanently, are you sure?",
	label_event:"Event",
	label_start:"Start",
	label_end:"End",
	label_details:"Notes",
	label_from: "from",
	label_to: "to",
	label_allday: "All day",
	label_time: "Time",
	label_no_events : "No Events",
	recurring: {
		none:"Never",
		daily:"Daily",
		day:"day(s)",
		every:"Every",
		weekly: "Weekly",
		week:"week(s) on",
		each:"Each",
		on_day: "on the",
		monthly: "Monthly",
		month: "month(s)",
		month_day:"on what day of the month",
		week_day:"on what day of the week",
		yearly: "Yearly",
		year: "year(s) in",
		counters:["the first","the second","the third", "the fourth", "the fifth"],
		never:"Never",
		repeat:"Repeat",
		end_repeat:"End repeat",
		endless_repeat:"Endless repeat",
		end_repeat_label: "Repeat will end by",
		edit_message: "Do you want to edit the whole set of repeated events?",
		edit_series: "Edit series",
		edit_occurrence: "Edit occurrence",
		delete_message: "Do you want to delete the whole set of repeated events?",
		delete_series: "Delete series",
		delete_occurrence: "Delete occurrence"
	}
};